BCC3D9<template>
  <div class="purchase">
    <div class="wrap">
      <div class="main">
        <div class="main_top">
          <div class="main_left">
          <!-- <header class="main__header">
          </header> -->
            <main class="main__content">
              <div class="step__sections">
                <div class="section section--shipping-address">
                  
                  <div class="selectAddress" v-if="addresses.length > 0">
                    <div class="section__header__purchase">
                      <div class="follow-steps">
                        <p>1</p>
                      </div>
                      <h2 class="delivery_info__select">{{ $t('deliveryInfoSelect') }}</h2>
                      <div
                        v-if="!this.checkoutWithinRadius && addressChoice"
                        class="time_tip__purchase"
                      >
                        <span class="error-message">{{ $t('notInArea') }}</span>
                      </div>
                      <!-- <div v-if="!addressChoice" class="time_tip">
                        <span>{{ $t('selectAddress') }}</span>
                      </div> -->
                    </div>
                    <div
                      style="marginBottom: 1em"
                      class="address-container"
                      v-if="addresses.length > 0"
                    >
                      <div style="margin: 0.2em" v-for="(address,index) in filterAddresses(addresses)" :key="index" data-index="index">
                        <el-radio
                          @change="validateDeliveryRadiusCheckout($event)"
                          v-model="addressChoice"
                          :label="address"
                        >
                          <div class="next-line" v-if="address.IsUSA">
                            <span>{{address.Street + ', ' + address.City + ', ' + address.State + ' ' + address.Zip}}</span>
                          </div>
                          <div class="next-line" v-else>
                            <span>{{address.Street}}</span>
                          </div>
                        </el-radio>
                      </div>
                    </div>
                  </div>

                  <!-- add address form -->
                  <div class="addAddress">
                    <div class="section__content" v-bind:style="{ marginBottom: 10 }">
                      <div class="title title1" :class="isAddAddress?'':'bg_none'" @click="addAddress">
                        <div style="display: flex;">
                          <i :class="isAddAddress?'el-icon-minus':'el-icon-plus'"></i>
                          <h2 class="title-add">{{ $t('addNewAddress') }}</h2>
                        </div>
                        <div>
                          <el-select v-model="isUSA" @change="locationChanged($event)">
                            <el-option
                              v-for="item in location"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value">
                            </el-option>
                          </el-select>
                        </div>
                      </div>
                      <el-form ref="addressForm" :rules="rules" :model="addressForm">
                        <div class="fieldset" v-show="isAddAddress">  
                          <!-- is usa or not -->
                          <!-- <div>
                            <p>Where is the address located? &nbsp;&nbsp;</p>
                            <el-radio-group v-model="addressForm.IsUSA">
                              <el-radio :label="true">US</el-radio>
                              <el-radio :label="false">Non-US</el-radio>
                            </el-radio-group>
                          </div> -->
                          <!-- end is usa or not -->
                          <div class="field">
                            <!-- is usa form -->
                            <div v-if="addressForm.IsUSA===true || addressForm.IsUSA==='true'">
                              <div class="two">
                                <div :class="firstName?'firstName':''" class="width">
                                  <el-form-item v-bind:label="$t('firstName')" prop="firstName">
                                    <el-input
                                      v-bind:placeholder="$t('firstName')"
                                      v-model="addressForm.FirstName"
                                      @keyup.native="contact"
                                    ></el-input>
                                  </el-form-item>
                                </div>
                                <div :class="lastName?'lastName':''" class="width">
                                  <el-form-item v-bind:label="$t('lastName')" prop="lastName">
                                    <el-input
                                      v-bind:placeholder="$t('lastName')"
                                      v-model="addressForm.LastName"
                                      @keyup.native="contact"
                                    ></el-input>
                                  </el-form-item>
                                </div>
                              </div>
                              <div class="address">
                                <div class="width" :class="phone?'phone':''">
                                  <el-form-item v-bind:label="$t('phone')" prop="phone">
                                    <el-input
                                      v-bind:placeholder="$t('mobilePhone')"
                                      v-model="addressForm.Telephone"
                                      @keyup.native="contact"
                                    ></el-input>
                                  </el-form-item>
                                </div>
                              </div>
                              <div :class="address?'address':''">
                                <el-form-item v-bind:label="$t('address')" prop="address">
                                  <el-input
                                    v-bind:placeholder="$t('addressIncludingApt')"
                                    v-model="addressForm.Street"
                                    @keyup.native="contact"
                                  ></el-input>
                                </el-form-item>
                              </div>
                              <div :class="city?'city':''">
                                <el-form-item v-bind:label="$t('city')" prop="city">
                                  <el-input
                                    v-bind:placeholder="$t('city')"
                                    v-model="addressForm.City"
                                    @keyup.native="contact"
                                  ></el-input>
                                </el-form-item>
                              </div>
                              <div class="three">
                                <div class="width_30">
                                  <div class="city">
                                    <el-form-item v-bind:label="$t('country')" prop="Country">
                                      <el-select v-model="addressForm.Country" value>
                                        <el-option
                                          v-for="item in CountryList"
                                          :key="item.value"
                                          :label="item.label"
                                          :value="item.value"
                                        ></el-option>
                                      </el-select>
                                    </el-form-item>
                                  </div>
                                </div>
                                <div class="width_30">
                                  <div class="city">
                                    <el-form-item v-bind:label="$t('state')" prop="State">
                                      <el-select
                                        v-model="addressForm.State"
                                        v-bind:placeholder="$t('pleaseSelect')"
                                        value=""
                                      >
                                        <el-option
                                          v-for="item in stateOptions"
                                          :key="item.value"
                                          :label="item.label"
                                          :value="item.value"
                                        ></el-option>
                                      </el-select>
                                    </el-form-item>
                                  </div>
                                </div>
                                <div class="width_30">
                                  <div :class="code?'code':''">
                                    <el-form-item v-bind:label="$t('zipCode')" prop="code">
                                      <el-input
                                        v-bind:placeholder="$t('zipCode')"
                                        v-model="addressForm.Zip"
                                        @keyup.native="contact"
                                      ></el-input>
                                    </el-form-item>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div v-else>
                              <div class="two">
                                <div :class="firstName?'firstName':''" class="width">
                                  <el-form-item v-bind:label="$t('firstName')" prop="firstName">
                                    <el-input
                                      v-bind:placeholder="$t('firstName')"
                                      v-model="addressForm.FirstName"
                                      @keyup.native="contact"
                                    ></el-input>
                                  </el-form-item>
                                </div>
                                <div :class="lastName?'lastName':''" class="width">
                                  <el-form-item v-bind:label="$t('lastName')" prop="lastName">
                                    <el-input
                                      v-bind:placeholder="$t('lastName')"
                                      v-model="addressForm.LastName"
                                      @keyup.native="contact"
                                    ></el-input>
                                  </el-form-item>
                                </div>
                              </div>
                              <div class="width">
                                <el-form-item
                                  prop="nonUSAddress"
                                  v-bind:label="$t('addressIncludingApt')"
                                >
                                  <el-input
                                    v-bind:placeholder="$t('nonUSAddress')"
                                    v-model="addressForm.Street"
                                  ></el-input>
                                </el-form-item>
                              </div>
                              <div class="width">
                                <el-form-item
                                  prop="mobilePhone"
                                  v-bind:label="$t('phone')"
                                >
                                  <el-input
                                    v-bind:placeholder="$t('phoneNumber')"
                                    v-model="addressForm.Telephone"
                                  ></el-input>
                                </el-form-item>
                              </div>
                              <div class="width">
                                <el-form-item
                                  prop="ssn"
                                  v-bind:label="$t('ssn')"
                                >
                                  <el-input
                                    v-bind:placeholder="$t('ssn')"
                                    v-model="addressForm.SSN"
                                  ></el-input>
                                </el-form-item>
                              </div>
                            </div>
                            <button
                              class="place btn"
                              @click="postNewAddress(addressForm, 'shipping', $event)"
                            >{{ $t('saveAddress') }}</button>
                          </div>
                        </div>
                      </el-form>
                    </div>
                  </div>
                  <!-- end add address form -->
                  
                </div>
              </div>
            </main>
            <!-- <div class="divider-2"></div> -->
          </div>
          <div class="main_right">
            <main class="main__content">
              <div class="step__sections">
                <div class="section section--shipping-address">
                  <div class="addPayment">
                    <div class="follow-steps">
                      <p>2</p>
                    </div>
                    <h2 class="section__title">{{ $t('choosePaymentMethod') }}</h2>
                    <div
                      v-show="!addressChoice && showPaymentError"
                      class="time_tip__purchase"
                    >
                      <span class="error-message">{{ $t('chooseValidAddressPay') }}</span>
                    </div>
                    <div class="payment-container">
                      <div v-if="!addressChoice" @click="showPaymentError=true">
                        <el-radio
                          class="radio-purchase"
                          :disabled="!addressChoice"
                          v-model="paymentMethod"
                          v-bind:label="$t('creditcard')"
                        >
                          <span>
                            <i class="far fa-credit-card fa-2x" style="color: #C0C4CC;"></i>
                          </span>
                        </el-radio>
                        <el-radio
                          class="radio-purchase"
                          :disabled="!addressChoice"
                          v-model="paymentMethod"
                          v-bind:label="$t('alipay')"
                        >
                          <span>
                            <i class="fab fa-alipay fa-2x" style="color: #C0C4CC;"></i>
                          </span>
                        </el-radio>
                        <el-radio
                          class="radio-purchase"
                          :disabled="!addressChoice"
                          v-model="paymentMethod"
                          v-bind:label="$t('wechatpay')"
                        >
                          <span>
                            <i class="fab fa-weixin fa-2x" style="color: #C0C4CC;"></i>
                          </span>
                        </el-radio>
                      </div>
                      <div v-else>
                        <el-radio class="radio-purchase" v-model="paymentMethod" label="creditcard">
                          <span>
                            <i class="far fa-credit-card fa-2x"></i>
                          </span>
                        </el-radio>
                        <el-radio class="radio-purchase" v-model="paymentMethod" label="alipay">
                          <span>
                            <i class="fab fa-alipay fa-2x"></i>
                          </span>
                        </el-radio>
                        <el-radio class="radio-purchase" v-model="paymentMethod" label="wechatpay">
                          <span>
                            <i class="fab fa-weixin fa-2x"></i>
                          </span>
                        </el-radio>
                      </div>
                    </div>
                    <!-- </header> -->
                    <div v-if="paymentMethod === 'creditcard'">
                      <div
                        v-if="paymentMethod === 'creditcard' && !this.cardLoading && !this.cardSuccess"
                        class="section__content"
                      >
                        <el-form ref="cardForm" :rules="rules" :model="cardForm">
                          <div class="fieldset" v-show="isAddPayment">
                            <div class="field">
                              <div>
                                <el-form-item
                                  v-bind:label="$t('cardHolderName')"
                                  prop="card_holder_name"
                                >
                                  <el-input
                                    v-bind:placeholder="$t('cardHolderName')"
                                    v-model="cardForm.card_holder_name"
                                    @keyup.native="contact"
                                  ></el-input>
                                </el-form-item>
                              </div>
                              <div>
                                <el-form-item v-bind:label="$t('creditCardNumber')" prop="Card">
                                  <el-input
                                    v-bind:placeholder="$t('creditCardNumber')"
                                    v-model="cardForm.Card"
                                    @keyup.native="contact"
                                    @input="cardNumberFormatter(cardForm.Card)"
                                  ></el-input>
                                </el-form-item>
                              </div>
                              <div class="two">
                                <div class="width">
                                  <el-form-item v-bind:label="$t('cardExpiration')" prop="Expiration">
                                    <el-input
                                      v-bind:placeholder="$t('cardExpiration')"
                                      v-model="cardForm.Expiration"
                                      @keyup.native="contact"
                                      @input="cardExpireDateFormatter(cardForm.Expiration)"
                                      :maxlength="5"
                                    ></el-input>
                                  </el-form-item>
                                </div>
                                <div class="width">
                                  <el-form-item v-bind:label="$t('cvc')" prop="CVC">
                                    <el-input
                                      v-bind:placeholder="$t('cvc')"
                                      v-model="cardForm.CVC"
                                      :maxlength="4"
                                      @keyup.native="contact"
                                    ></el-input>
                                  </el-form-item>
                                </div>
                              </div>
                              
                              <!-- billing address -->
                              <div class="billing_address_selection">
                                <div class="time_tip"><span>{{ $t('selectBillingAddress') }}</span></div>
                                <el-checkbox v-model="billingAddressSame">Same as Shipping Address</el-checkbox>
                              </div>
                              <!-- can select from address book ?? -->
                              <div v-if="!billingAddressSame && addresses.length > 0" style="marginBottom: 1em" class="address-container">
                                <div style="margin: 0.2em" v-for="address in addresses">
                                  <el-radio
                                    @change="validateDeliveryRadiusCheckout($event)"
                                    v-model="billingAddress"
                                    :label="address"
                                  >
                                    <div class="next-line" v-if="address.IsUSA">
                                      <span>{{address.Street + ', ' + address.City + ', ' + address.State + ' ' + address.Zip}}</span>
                                    </div>
                                    <div class="next-line" v-else>
                                      <span>{{address.Street}}</span>
                                    </div>
                                  </el-radio>
                                </div>
                              </div>
                              
                              <div v-if="!billingAddressSame" class="addAddress">
                                <div class="section__content" v-bind:style="{ marginBottom: 10 }">
                                  <div class="title" :class="isAddBilling?'':'bg_none'" @click="addBilling">
                                    <i :class="isAddBilling?'el-icon-minus':'el-icon-plus'"></i><span>{{ $t('addNewAddress') }}</span>
                                  </div>
                                  <div class="fieldset" v-show="isAddBilling">
                                    <div class="field">
                                        <div class="two">
                                          <div :class="firstName?'firstName':''" class="width">
                                            <el-form-item v-bind:label="$t('firstName')" prop="firstName">
                                              <el-input v-bind:placeholder="$t('firstName')" v-model="BillingForm.FirstName"
                                                        @keyup.native="contact"></el-input>       
                                            </el-form-item>
                                          </div>
                                          <div :class="lastName?'lastName':''" class="width">
                                            <el-form-item v-bind:label="$t('lastName')" prop="lastName">
                                              <el-input v-bind:placeholder="$t('lastName')" v-model="BillingForm.LastName"
                                                        @keyup.native="contact"></el-input>       
                                            </el-form-item>
                                          </div>
                                        </div>
                                        <div :class="address?'address':''">
                                          <el-form-item v-bind:label="$t('address')" prop="address">
                                            <el-input v-bind:placeholder="$t('addressIncludingApt')" v-model="BillingForm.Street"
                                                      @keyup.native="contact"></el-input>      
                                          </el-form-item>
                                        </div>
                                        <div class="address">
                                          <div class="width" :class="phone?'phone':''">
                                            <el-form-item v-bind:label="$t('phone')" prop="phone">
                                              <el-input v-bind:placeholder="$t('phone')" v-model="BillingForm.Telephone"
                                                        @keyup.native="contact"></el-input>
                                            </el-form-item>
                                          </div>
                                        </div>
                                        <div :class="city?'city':''">
                                          <el-form-item v-bind:label="$t('city')" prop="city">
                                            <el-input
                                              v-bind:placeholder="$t('city')"
                                              v-model="BillingForm.City"
                                              @keyup.native="contact"
                                            ></el-input>
                                          </el-form-item>
                                        </div>
                                        <div class="three">
                                          <div class="width_30">
                                            <div class="city">
                                              <el-form-item v-bind:label="$t('country')" prop="Country">
                                                <el-select v-model="BillingForm.Country" value="">
                                                  <el-option
                                                    v-for="item in CountryList"
                                                    :key="item.value"
                                                    :label="item.label"
                                                    :value="item.value"
                                                  >
                                                  </el-option>
                                                </el-select>
                                              </el-form-item>
                                            </div>
                                          </div>
                                          <div class="width_30">
                                            <div class="city">
                                              <el-form-item v-bind:label="$t('state')" prop="State">
                                                <el-select
                                                  v-model="BillingForm.State"
                                                  v-bind:placeholder="$t('pleaseSelect')"
                                                  value=""
                                                >
                                                  <el-option
                                                    v-for="item in stateOptions"
                                                    :key="item.value"
                                                    :label="item.label"
                                                    :value="item.value"
                                                  >
                                                  </el-option>
                                                </el-select>
                                              </el-form-item>
                                            </div>
                                          </div>
                                          <div class="width_30">
                                            <div>
                                              <el-form-item v-bind:label="$t('zipCode')" prop="code">
                                                <el-input v-bind:placeholder="$t('zipCode')" v-model="BillingForm.Zip" @keyup.native="contact"></el-input>
                                              </el-form-item>
                                            </div>
                                          </div>
                                        </div>
                                      <button class="place btn" @click="postNewAddress(BillingForm, 'billing', $event)">{{ $t('saveAddress') }}</button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <!-- end billing address -->
              
                              <span v-show="cardError" style="color:red">{{cardError}}</span>
                              <el-button
                                @click="fetchCardToken()"
                                class="place btn"
                              >{{ $t('submitCardInfo') }}</el-button>
                            </div>
                          </div>
                        </el-form>
                      </div>
                      <div v-else-if="this.cardLoading" class="svg">
                        <svg
                          version="1.1"
                          id="loader-1"
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                          x="0px"
                          y="0px"
                          width="120px"
                          height="120px"
                          viewBox="0 0 50 50"
                          style="enable-background:new 0 0 50 50;"
                          xml:space="preserve"
                        >
                          <path
                            fill="#29327F"
                            d="M25.251,6.461c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615V6.461z"
                          >
                            <animateTransform
                              attributeType="xml"
                              attributeName="transform"
                              type="rotate"
                              from="0 25 25"
                              to="360 25 25"
                              dur="1s"
                              repeatCount="indefinite"
                            />
                          </path>
                        </svg>
                      </div>
                      <div v-else-if="!this.cardLoading && this.cardSuccess">
                        <h3>{{ $t('cardSubmitSuccess') }}</h3>
                      </div>
                    </div>
                  </div>

                <!-- <div v-if="paymentMethod === 'creditcard'" class="addCreditCard">
                  <div
                    v-if="paymentMethod === 'creditcard' && !this.cardLoading && !this.cardSuccess"
                    class="section__content"
                  >
                    <div
                      class="title"
                      :class="isAddPayment?'':'bg_none'"
                      @click="isAddPayment = !isAddPayment"
                    >
                      <i :class="isAddPayment?'el-icon-minus':'el-icon-plus'"></i>
                      <h2 class="title-add">{{ $t('creditCardInfo') }}</h2>
                    </div>
                    <div class="fieldset" v-show="isAddPayment">
                      <div class="field">
                        <div>
                          <el-form-item
                            v-bind:label="$t('cardHolderName')"
                            prop="card_holder_name"
                          >
                            <el-input
                              v-bind:placeholder="$t('cardHolderName')"
                              v-model="sizeForm.card_holder_name"
                              @keyup.native="contact"
                            ></el-input>
                          </el-form-item>
                        </div>
                        <div>
                          <el-form-item v-bind:label="$t('creditCardNumber')" prop="Card">
                            <el-input
                              v-bind:placeholder="$t('creditCardNumber')"
                              v-model="sizeForm.Card"
                              @keyup.native="contact"
                              @input="cardNumberFormatter(sizeForm.Card)"
                            ></el-input>
                          </el-form-item>
                        </div>
                        <div class="two">
                          <div class="width">
                            <el-form-item v-bind:label="$t('cardExpiration')" prop="Expiration">
                              <el-input
                                v-bind:placeholder="$t('cardExpiration')"
                                v-model="sizeForm.Expiration"
                                @keyup.native="contact"
                                @input="cardExpireDateFormatter(sizeForm.Expiration)"
                                :maxlength="5"
                              ></el-input>
                            </el-form-item>
                          </div>
                          <div class="width">
                            <el-form-item v-bind:label="$t('cvc')" prop="CVC">
                              <el-input
                                v-bind:placeholder="$t('cvc')"
                                v-model="sizeForm.CVC"
                                :maxlength="4"
                                @keyup.native="contact"
                              ></el-input>
                            </el-form-item>
                          </div>
                        </div>
                        <span v-show="cardError" style="color:red">{{cardError}}</span>
                        <el-button
                          @click="fetchCardToken()"
                          class="place btn"
                        >{{ $t('submitCardInfo') }}</el-button>
                      </div>
                    </div>
                  </div>
                  <div v-else-if="this.cardLoading" class="svg">
                    <svg
                      version="1.1"
                      id="loader-1"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      width="120px"
                      height="120px"
                      viewBox="0 0 50 50"
                      style="enable-background:new 0 0 50 50;"
                      xml:space="preserve"
                    >
                      <path
                        fill="#29327F"
                        d="M25.251,6.461c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615V6.461z"
                      >
                        <animateTransform
                          attributeType="xml"
                          attributeName="transform"
                          type="rotate"
                          from="0 25 25"
                          to="360 25 25"
                          dur="1s"
                          repeatCount="indefinite"
                        />
                      </path>
                    </svg>
                  </div>
                  <div v-else-if="!this.cardLoading && this.cardSuccess">
                    <h3>{{ $t('cardSubmitSuccess') }}</h3>
                  </div>
                </div> -->

                <span v-show="cardError" style="color:red">{{cardError}}</span>
              </div>
            </div>
          </main>
        </div>
      </div>

      <!--credit and promo-->
      <!-- <div class="main_bottom">
        <div class="divider-2"></div>
        <footer class="main__footer" v-if="this.necessaryCartItems.AvailableCredit !== 0">
          <h2 class="section__title">{{ $t('userCredit') }}</h2>
          <div style="marginTop: 20px; marginBottom: 20px">
            <el-checkbox
              v-model="IsCreditUsed"
              :disabled="!addressChoice || !this.checkoutWithinRadius"
            ></el-checkbox>
            <span style="marginLeft: 10px; fontSize: 17px">
              {{ $t('use_my_credit_balance') }}
              <span
                style="color: red"
              >(${{this.necessaryCartItems.AvailableCredit}})</span>
            </span>
          </div>
        </footer>
        <footer v-if="!this.promoCodeLoading" class="main__footer">
          <div class="follow-steps">
            <p>3</p>
          </div>
          <h2 class="section__title">{{ $t('promoCode') }}</h2>
          <div class="discount" :class="promoCode ? 'discountCode' : ''">
            <el-form-item v-bind:label="$t('discountCode')">
              <el-input
                v-bind:placeholder="$t('enterCode')"
                v-model="promoCode"
                @keyup.native="contact"
              ></el-input>
              <span class="apply" @click="validatePromotionCode($event)">
                <i class="el-icon-right"></i>
              </span>
            </el-form-item>
          </div>
          <span style="color:red;" v-show="this.promoCodeValid">{{ this.promoCodeValid}}</span>
          <span
            style="color:red;"
            v-show="this.promoCodeSuccessful && !this.promoCodeLoading && !this.promoCodeValid"
          >{{ $t('promoApplied') }}</span>
        </footer>
        <div v-else-if="this.promoCodeLoading && !this.promoCodeSuccessful" class="svg">
          <svg
            version="1.1"
            id="loader-1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            width="120px"
            height="120px"
            viewBox="0 0 50 50"
            style="enable-background:new 0 0 50 50;"
            xml:space="preserve"
          >
            <path
              fill="#29327F"
              d="M25.251,6.461c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615V6.461z"
            >
              <animateTransform
                attributeType="xml"
                attributeName="transform"
                type="rotate"
                from="0 25 25"
                to="360 25 25"
                dur="1s"
                repeatCount="indefinite"
              />
            </path>
          </svg>
        </div>
      </div>
      <div class="divider-2"></div> -->
      <!--end credit and promo-->
      
      <div class="complementary">
        <div class="items-top-bar">
          <span>{{ $t('orderDetail') }}</span>
        </div>
        <div class="complementary-inside">
          <h2 class="section__title">{{ $t('orderSummary') }}</h2>
          <div class="sidebar">
            <div class="sidebar__content">
              <div class="orderList">
                <ul>
                  <li
                    v-for="(item,index) in this.$store.state.cart.cartProductsList.Sales_Order_Lines"
                    :key="index"
                  >
                    <div class="img">
                      <img :src="item.Thumbnail" alt />
                      <span class="orderNum">{{item.Quantity}}</span>
                    </div>
                    <div class="min">
                      <span v-if="$i18n.locale=='en'">{{item.Name}}</span>
                      <span v-if="$i18n.locale=='ch'">{{item.Description}}</span>
                       <div>
                        <button :disabled="addDisabled || item.Quantity < 2" @click="decreaseAddToCart(item, $event)" class="decrement">-</button>
                        <i :disabled="addDisabled" @click="confirmDeleteItem = true; currentDeleteItem = item;" class="fa fa-trash-o decrement-trash"  aria-hidden="true"></i>
                        <button :disabled="addDisabled" @click="throttleAddToCart(item, $event)" class="increment">+</button>
                      </div>
                    </div>
                    <div class="price">${{item.TotalPrice.toFixed(2)}}</div>
                  </li>
                </ul>
                <div class="comput">
                  <div class="lilist">
                    <div class="left">{{ $t('subtotal') }}</div>
                    <div v-if="this.TotalPrice" class="right">${{this.TotalPrice.toFixed(2)}}</div>
                  </div>
                  <div class="lilist">
                    <div class="left">{{ $t('promotion') }}</div>
                    <div class="right">-${{this.Savings.toFixed(2)}}</div>
                  </div>
                  <div class="lilist">
                    <div class="left">{{ $t('tax') }}</div>
                    <div v-if="this.necessaryCartItems.Tax || this.necessaryCartItems.Tax === 0" class="right">${{this.necessaryCartItems.Tax.toFixed(2)}}</div>
                  </div>
                  <div class="lilist">
                    <div class="left">{{ $t('shipping') }}</div>
                    <div v-if="this.$store.state.cart.necessaryCartItems.Delivery || this.$store.state.cart.necessaryCartItems.Delivery === 0" class="right">${{this.$store.state.cart.necessaryCartItems.Delivery.toFixed(2)}}</div>
                  </div>
                   <!-- <div v-if="this.IsShareCreditUsed" class="lilist">
                    <div class="left">{{ $t('sharingDiscount') }}</div>
                    <div v-if="this.$store.state.cart.necessaryCartItems.ShareCreditAmount" class="right">-${{this.$store.state.cart.necessaryCartItems.ShareCreditAmount.toFixed(2)}}</div>
                  </div> -->
                </div>

                <div class="Tol">
                  <div v-if="this.IsShareCreditUsed" class="left">{{ $t('total') }}</div>
                  <div v-if="!this.IsShareCreditUsed" class="left"></div>
                  <div class="right">
                    <span class="new-red" v-if="!this.IsShareCreditUsed">{{ $t('total') }}</span>
                    <span class="new-red" v-if="this.IsShareCreditUsed">{{ $t('originalTotal') }}</span>
                    <!-- <span>USD</span> -->
                    <span v-if="!this.IsShareCreditUsed" style="marginLeft: 20px" class="new-red">${{this.GrandTotal}}</span>
                    <span v-if="this.IsShareCreditUsed && this.GrandTotal && this.$store.state.cart.necessaryCartItems.ShareCreditAmount" style="marginLeft: 20px" class="new-red">${{(Number(this.GrandTotal) + this.$store.state.cart.necessaryCartItems.ShareCreditAmount).toFixed(2)}}</span>
                  </div>
                </div>
                <div class="err" v-if="this.orderFailed">
                  <span class="error-message">Error: {{this.orderFailMessage}}</span>
                </div>
              </div>
              
              <!-- <div class="sharePay">
                <p class="shareExplain" v-if="this.$store.state.cart.necessaryCartItems.ShareCreditAmount">{{ $t('shareExplain1') }}<span style="color: rgb(127, 226, 80)">${{(this.$store.state.cart.necessaryCartItems.ShareCreditAmount).toFixed(2)}}</span>{{ $t('shareExplain2') }}</p>
                <p class="shareSaved" v-if="this.$store.state.cart.necessaryCartItems.ShareCreditAmount">{{ $t('savingsPrice') }}${{(this.GrandTotal-(this.IsShareCreditUsed ? 0 : this.$store.state.cart.necessaryCartItems.ShareCreditAmount)).toFixed(2)}}</p>
                <div class="pay">
                  <el-button
                    v-if="!this.IsShareCreditUsed && this.GrandTotal && this.$store.state.cart.necessaryCartItems.ShareCreditAmount"
                    :disabled="false"
                    @click="shareModalOpen = true"
                    class="place btn">
                    {{ $t('shareForDiscount') }} (${{(this.GrandTotal-this.$store.state.cart.necessaryCartItems.ShareCreditAmount).toFixed(2)}})
                  </el-button>
                  <p class="sharingThank" v-if="this.IsShareCreditUsed">{{ $t('sharingThank') }}</p>
                </div>
              </div>
              <div class="normalPay">
                <div class="pay">
                  <el-button
                    :disabled="!isFormValidForSubmission()"
                    @click="onSubmit('sizeForm')"
                    class="place btn"
                  >{{ $t('payForOrder') }}（${{this.GrandTotal}})</el-button>
                </div>
             </div> -->

              <!-- START COMMENT HERE -->
              <!-- <div v-if="!this.IsShareCreditUsed" class="sharePay2">
                <div v-if="!this.IsShareCreditUsed && this.GrandTotal && this.$store.state.cart.necessaryCartItems.ShareCreditAmount" style="marginTop: 10px">
                  <span class="sh1">{{ $t('shareToCircle') }}</span>
                  <span v-if="this.$store.state.cart.necessaryCartItems.ShareCreditPercentage" class="sh2">{{this.$store.state.cart.necessaryCartItems.ShareCreditPercentage*100}}%</span>
                  <span v-if="$i18n.locale=='en'" class="sh3e">{{ $t('priceAfterShare') }}&nbsp;&nbsp;${{(Number(this.GrandTotal)-this.$store.state.cart.necessaryCartItems.ShareCreditAmount).toFixed(2)}}</span>
                  <span v-if="$i18n.locale=='ch'" class="sh3c">{{ $t('priceAfterShare') }}&nbsp;&nbsp;${{(Number(this.GrandTotal)-this.$store.state.cart.necessaryCartItems.ShareCreditAmount).toFixed(2)}}</span>
                </div>
                <span class="sh5">{{ $t('goShare') }}</span>
                <div class="sh6">
                  <span class="sh5m">{{ $t('goShare') }}</span>
                  <img @click="onClickShareWechat" class="wechat-icon-container" src="../assets/img/wechat_icon.png">
                  <ShareNetwork
                    v-for="network in networks"
                    :network="network.network"
                    :key="network.network"
                    :url="sharing.url"
                    :title="sharing.title"
                    :description="sharing.description"
                    :quote="sharing.quote"
                    :hashtags="sharing.hashtags"
                    :twitterUser="sharing.twitterUser"
                    @open="sharingClosed"
                  >
                    <img class="icon" :src="network.icon" alt />
                  </ShareNetwork>
                </div>
              </div> -->
              <!-- END COMMENT HERE -->
              <!-- NEW HERE START -->
              <!-- <div v-if="!this.IsShareCreditUsed" class="sharePay4">
                <div v-if="!this.IsShareCreditUsed && this.GrandTotal && this.$store.state.cart.necessaryCartItems.ShareCreditAmount" class="sharePay4-inside-2">
                  <span class="shx">{{ $t('priceAfterShare') }}&nbsp;&nbsp;&nbsp;&nbsp;${{(Number(this.GrandTotal)-this.$store.state.cart.necessaryCartItems.ShareCreditAmount).toFixed(2)}}</span>
                </div>
                <div v-if="!this.IsShareCreditUsed && this.GrandTotal && this.$store.state.cart.necessaryCartItems.ShareCreditAmount" class="sharePay4-inside-1">
                  <span v-if="$i18n.locale=='en' && this.$store.state.cart.necessaryCartItems.ShareCreditPercentage" class="sh1">Share For {{this.$store.state.cart.necessaryCartItems.ShareCreditPercentage*100}}% Discount</span>
                  <span v-if="$i18n.locale=='ch' && this.$store.state.cart.necessaryCartItems.ShareCreditPercentage" class="sh1">分享到朋友圈立减 {{this.$store.state.cart.necessaryCartItems.ShareCreditPercentage*100}}%</span>
                  <img @click="onClickShareWechat" class="wechat-icon-container" src="../assets/img/wechat_icon.png">
                  <ShareNetwork
                    v-for="network in networks"
                    :network="network.network"
                    :key="network.network"
                    :url="sharing.url"
                    :title="sharing.title"
                    :description="sharing.description"
                    :quote="sharing.quote"
                    :hashtags="sharing.hashtags"
                    :twitterUser="sharing.twitterUser"
                    @open="sharingClosed"
                  >
                    <img class="icon" :src="network.icon" alt />
                  </ShareNetwork>
                </div>
              </div> -->
              <!-- NEW HERE END -->
              <!-- <div v-if="this.IsShareCreditUsed" class="sharePay3 orderList">
                <div class="Tol">
                  <div v-if="this.IsShareCreditUsed" class="left">{{ $t('sharingDiscount') }}</div>
                  <div class="left"></div>
                  <div class="right">
                    <span v-if="this.$store.state.cart.necessaryCartItems.ShareCreditAmount" style="marginLeft: 20px" class="new-red">-${{this.$store.state.cart.necessaryCartItems.ShareCreditAmount.toFixed(2)}}</span>
                  </div>
                </div>
                <div class="sh7">
                  <span>{{ $t('whatYouPay') }}</span>
                  <span class="sh8">${{this.GrandTotal}}</span>
                </div>
              </div> -->

              <div class="normalPay">
                <!-- <div v-if="!this.IsShareCreditUsed" class="pay">
                  <el-button
                    :disabled="!isFormValidForSubmission()"
                    @click="onSubmit()"
                    class="skip-place btn"
                  >
                  {{ $t('skipShare') }}
                  </el-button>
                </div> -->
                <div class="pay">
                  <el-button
                    :disabled="!isFormValidForSubmission()"
                    @click="onSubmit()"
                    class="noskip-place btn"
                  >
                  {{ $t('checkOut') }}
                  </el-button>
                </div>
             </div>

            </div>
          </div>
          </div>
        </div>

        <!-- <transition name="modal" v-if="shareModalOpen">
          <div class="modal-mask" @click="shareModalOpen = false">
            <div class="modal-wrapper">
              <div class="modal-container2">
                <div>
                  <img @click="onClickShareWechat" class="wechat-icon-container" src="../assets/img/wechat_icon.png">
                  <ShareNetwork
                    v-for="network in networks"
                    :network="network.network"
                    :key="network.network"
                    :url="sharing.url"
                    :title="sharing.title"
                    :description="sharing.description"
                    :quote="sharing.quote"
                    :hashtags="sharing.hashtags"
                    :twitterUser="sharing.twitterUser"
                    @open="sharingClosed"
                  >
                    <img class="icon" :src="network.icon" alt />
                  </ShareNetwork>
                </div>
              </div>
            </div>
          </div>
        </transition> -->

        <!-- <el-dialog
          :title="$t('wechat_share')"
          :visible.sync="wechatModalOpen"
          class="myWechatDia"
        >
          <share :config="config"></share>    
        </el-dialog> -->
      </div>
    </div>

    <transition name="modal" v-if="detectedGroupItemModal">
      <div class="modal-mask" @click="detectedGroupItemModal = false">
        <div class="modal-wrapper">
          <div class="modal-container3" @click.stop>
              <div class="infoctn">
              <p class="info" style="color: #BCC3D9">{{ $t('groupFollowingItem') }}</p>
            </div>
              <div class="infoctn">
              <p v-if="$i18n.locale=='en'" class="info">{{ detectedGroupItem.Name }}</p>
              <p v-if="$i18n.locale=='ch'" class="info">{{ detectedGroupItem.Description }}</p>
            </div>
            <div class="infoctn">
              <p class="info" style="color: #BCC3D9">{{ $t('groupPleaseRemove') }}</p>
            </div>
            <div class="btnctn">
              <button @click="detectedGroupItemModal = false" class="btn" >{{ $t('close') }}</button>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <transition name="modal" v-if="confirmDeleteItem">
      <div class="modal-mask" @click="confirmDeleteItem = false">
        <div class="modal-wrapper">
          <div class="modal-container-delete-item" @click.stop>
              <div class="infoctn">
              <p class="info">{{ $t('cofirmDeleteWarning') }}</p>
            </div>
            <div class="infoctn">
              <p v-if="$i18n.locale=='en'" class="info-gray">{{ currentDeleteItem.Name }}</p>
              <p v-if="$i18n.locale=='ch'" class="info-gray">{{ currentDeleteItem.Description }}</p>
            </div>
            <div class="btnctn">
              <button style="marginRight: 5px" @click="confirmDeleteItem = false" class="btn" >{{ $t('cancel') }}</button>
              <button style="marginLeft: 5px" @click="deleteItem(currentDeleteItem)" class="btn" >{{ $t('confirm') }}</button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import { validateZipCode, validatePhoneNumber } from "../../config/validation";
import Vue from "vue";
import moment from "moment";
import addresses from "../store/modules/addresses";
import VueSocialSharing from "vue-social-sharing";
Vue.use(VueSocialSharing);
import Share from 'vue-social-share'
Vue.use(Share)

import { isUserAuthenticated } from "../store/modules/cart";
import fbicon from "../assets/img/facebook_icon.png";
import twittericon from "../assets/img/twitter_icon.png";
import pinteresticon from "../assets/img/pinterest_icon.png";
import whatsappicon from "../assets/img/whatsapp_icon.png";
import lineicon from "../assets/img/line_icon.png";
import wechaticon from "../assets/img/wechat_icon.png";

export default {
  name: "purchase",
  data() {
    return {
      addDisabled: false,
      confirmDeleteItem: false,
      currentDeleteItem: null,

      wechatTimeout: null,
      scrollPosition: null,
      accordionOpen: "accordion",
      labelPosition: "top",
      address: "",
      promoCode: "",
      card_holder_name: "",
      order: false,
      radio: "",
      deliveryTime: "",
      creditCardSuccess: false,
      formLabelAlign: {
        name: "",
        password: "",
      },
      showPaymentError: false,
      paymentMethod: "creditcard",
      Subtotal: 15,
      total: 15,
      addressChoice: "",
      addressSelection: null,
      billingAddress: '',
      billingAddressSame: true,
      isUSA: (localStorage.getItem('isUSA')==='true') ? 'USA' : 'None USA',
      location:[{
        value: true,
        label:'USA',
      },{
        value: false,
        label:'None USA',
      }],
      addressForm: {
        name: "",
        SSN: "",
        subscribe: true,
        IsUSA: localStorage.getItem('isUSA'),
        FirstName: "",
        LastName: "",
        Telephone: "",
        Street: "",
        City: "",
        Zip: "",
        Country: "United States",
        State: "",
      },
      cardForm: {
        confirmAddress: "",
        Card: "",
        Expiration: "",
        CVC: "",
        storage: true,
        card_holder_name: "",
      },
      isAddBilling: false,
      BillingForm: {
        FirstName: "",
        LastName: "",
        Street: "",
        Telephone: "",
        City: "",
        Zip: "",
        Country: "United States",
        State: "",
      },
      rules: {
        FirstName: [
          {
            required: true,
            message: this.$t('firstNameRequired'),
            trigger: "blur",
          },
          {
            min: 1,
            max: 20,
            message: this.$t('firstNameLengthRequired'),
            trigger: "blur",
          },
        ],
        LastName: [
          { 
            required: true,
            message: this.$t('lastNameRequired'),
            trigger: "blur"
          },
          {
            min: 1,
            max: 20,
            message: this.$t('lastNameLengthRequired'),
            trigger: "blur",
          },
        ],
        Street: [
          { required: true, message: this.$t('addressRequired'), trigger: "blur" },
          {
            min: 2,
            max: 30,
            message: "address length at least 3",
            trigger: "blur",
          },
        ],
        City: [
          { required: true, message: "City is Required", trigger: "blur" },
          {
            min: 3,
            max: 20,
            message: "city length at least 3",
            trigger: "blur",
          },
        ],
        Zip: [
          { required: true, message: "Zip Code is Required", trigger: "blur" },
          {
            min: 3,
            max: 5,
            message: "code length at least 3",
            trigger: "blur",
          },
        ],
        Telephone: [
          {
            required: true,
            message: "Phone Number is Required",
            trigger: "blur",
          },
          {
            min: 3,
            max: 12,
            message: "phone length at least 3",
            trigger: "blur",
          },
        ],
        Country: [
          { required: true, message: "Country is Required", trigger: "blur" },
          {
            min: 3,
            max: 20,
            message: "Country length at least 3",
            trigger: "blur",
          },
        ],
        Card: [
          { required: true, message: "Card Info is Required", trigger: "blur" },
          {
            min: 16,
            max: 23,
            message: "Card number should be 13 - 19 digits",
            trigger: "blur",
          },
        ],
        Expiration: [
          {
            required: true,
            message: "Expiration Date is Required",
            trigger: "blur",
          },
          {
            min: 5,
            max: 5,
            message: "Expiration data shoud be in format MM/YY",
            trigger: "blur",
          },
        ],
        CVC: [
          {
            required: true,
            message: "Security Code is Required",
            trigger: "blur",
          },
          { min: 3, max: 4, message: "CVC length at least 3", trigger: "blur" },
        ],
      },
      //下拉框默认数据
      stateOptions: this.$store.state.addresses.states, // States drop down data
      CountryList: [
        // {
        //   value: "",
        //   label: "---",
        // },
        {
          value: "United States",
          label: "United States",
        },
      ],

      // input label
      input_label: false,
      firstName: false,
      lastName: false,
      addressName: "",
      apartment: false,
      city: false,
      code: false,
      phone: false,
      privacy: false,
      refund: false,
      // end input label

      //商品列表默认数据
      isAddAddress: false, //展示添加地址
      isAddPayment: true, //展示添加支付方式

      //user credit
      IsCreditUsed: false,

      //sharing
      sharing: {
        url: "https://www.newbiotechcorp.com",
        title: "This is the Title.",
        description: "This is the Description.",
        quote: "This is the Quote.",
        hashtags: "New Biotech,hashtag,test",
        twitterUser: "",
      },
      networks: [
        {
          network: "facebook",
          name: "Facebook",
          icon: fbicon,
        },
        // {
        //   network: "facebook",
        //   name: "Facebook",
        //   icon: wechaticon,
        // },
        {
          network: "twitter",
          name: "Twitter",
          icon: twittericon,
        },
        {
          network: "pinterest",
          name: "Pinterest",
          icon: pinteresticon,
        },
        {
          network: "whatsapp",
          name: "Whatsapp",
          icon: whatsappicon,
        },
        {
          network: "line",
          name: "Line",
          icon: lineicon,
        },
      ],
      config: {
        url: 'https://www.newbiotechcorp.com',
        title: 'New Biotech',
        description: 'New Biotech',
        sites: ['wechat'],
        wechatQrcodeTitle: "",
        wechatQrcodeHelper: "",
      },
      shareModalOpen: false,
      wechatModalOpen: false,
      detectedGroupItem: {},
      detectedGroupItemInv: {},
      detectedGroupItemModal: false,
      errors: [],
      checkoutErrors: [],
      shipstation: {},
    };
  },
  methods: {
    ...mapActions("addresses", ["fetchMLMNetwork"]),
    ...mapActions('products',["fetchGroupBuyWithId"]),
    ...mapMutations("products", ["updateActiveProduct"]),
    ...mapMutations("checkout", [
      "setPricesForCheckout",
      "saveTotalPrice",
      "saveGrandTotal",
      "clearPromoCode",
      "clearCard",
      "updatePromoCode",
      "updateIsShareCreditUsed",
      "resetShipstationData",
    ]),
    ...mapActions('cart',['addProductToCart']),
    onClickShareWechat() {
      this.shareModalOpen = false;
      this.wechatModalOpen = true;
    },
    sharingClosed() {
      localStorage.setItem('shareCreditUsed', true);
      this.updateIsShareCreditUsed(true);
    },
    cardNumberFormatter(value) {
      var v = value.replace(/\s+/g, "").replace(/[^0-9]/gi, "");
      var matches = v.match(/\d{4,19}/g);
      var match = (matches && matches[0]) || "";
      var parts = [];

      for (var i = 0, len = match.length; i < len; i += 4) {
        parts.push(match.substring(i, i + 4));
      }
      if (parts.length) {
        this.cardForm.Card = parts.join(" ");
      } else {
        this.cardForm.Card = value;
      }
    },
    cardExpireDateFormatter(date) {
      if (date.length == 3) {
        if (date[date.length - 1] !== "/") {
          var temp = this.cardForm.Expiration.split("");
          temp.splice(2, 0, "/");
          this.cardForm.Expiration = temp.join("");
          return;
        } else {
          this.cardForm.Expiration = this.cardForm.Expiration.slice(0, 2);
        }
      }
    },
    contact(el) {
      this.addressForm.name !== ""
        ? (this.input_label = true)
        : (this.input_label = false);
      this.addressForm.FirstName !== ""
        ? (this.firstName = true)
        : (this.firstName = false);
      this.addressForm.LastName !== ""
        ? (this.lastName = true)
        : (this.lastName = false);
      this.addressForm.Street !== ""
        ? (this.address = true)
        : (this.address = false);
      this.addressForm.City !== "" ? (this.city = true) : (this.city = false);
      this.addressForm.Zip !== "" ? (this.code = true) : (this.code = false);
      this.addressForm.Telephone !== "" ? (this.phone = true) : (this.phone = false);
      // this.sizeForm.discountCode !== '' ? this.discountCode = true : this.discountCode = false
    },
    updateScroll() {
      this.scrollPosition = this.$refs.infoBox.clientHeight - window.scrollY;
    },
    refundShow() {
      this.refund = !this.refund;
    },
    validatePromotionCode(e) {
      e.preventDefault();
      this.$store
        .dispatch("checkout/validatePromoCode", [
          this.promoCode,
          this.TotalPrice,
        ])
        .then(() => {
          let cartItems = {};
          cartItems.SalesOrder_id = this.$store.state.cart.cartProductsList.SalesOrder_id;
          cartItems.Sales_Order_Lines = this.$store.state.cart.cartProductsList.Sales_Order_Lines;
          cartItems.ShippingMethod = "Delivery";
          cartItems.Tip = 0;
          cartItems.TipPercentage = 0;
          cartItems.TotalPrice = this.$store.state.cart.cartProductsList.TotalPrice;
          cartItems.PromoCode = this.PromoCode;
          cartItems.IsCreditUsed = this.IsCreditUsed;
          cartItems.IsShareCreditUsed = this.IsShareCreditUsed;
          const isUSA = localStorage.getItem('isUSA');
          if (isUSA === false || isUSA === 'false') {
            cartItems.Tax = 0;
            cartItems.Delivery = 24;
          } else {
            cartItems.Delivery = this.shipstation.shipmentCost + this.shipstation.otherCost;
          }
          cartItems.Zip = this.addressChoice.Zip;
          this.$store.dispatch("cart/saveAndAdjustCart", cartItems);
          this.saveTotalPrice(this.necessaryCartItems.TotalPrice);
        });
    },
    checkForm: async function (form) {
      this.errors = [];
      if (!form.Street) {
        this.errors.push(this.$t("addressRequired"));
      }
      if (!form.City) {
        this.errors.push(this.$t("cityRequired"));
      }
      if (!form.Country) {
        this.errors.push(this.$t("countryRequired"));
      }
      if (!form.State) {
        this.errors.push(this.$t("stateRequired"));
      }
      if (validateZipCode(form.Zip)) this.errors.push(this.$t("zipCodeWrong"));
      if (validatePhoneNumber(form.Telephone))
        this.errors.push(this.$t("phoneNumberWrong"));
    },
    locationChanged(e){
      localStorage.setItem('isUSA', e);
      this.$router.go(0);
    },
    postNewAddress(form, type, event) {
      event.preventDefault();
      const isUSA = localStorage.getItem('isUSA');
      if (type === 'billing') { form.Type = 'Billing' }
      if (isUSA === true || isUSA === 'true') {
        form.IsUSA = true;
        this.checkForm(form);
      } else { form.Country = ''; form.IsUSA = false;}
      if (!this.errors.length) {
        this.$store.dispatch("addresses/postAddress", form).then(() => {
          this.$store.dispatch("addresses/fetchAddresses");
          this.isAddAddress = false;
          this.isAddBilling = false;
          this.clearAddressForm();
        });
      } else {
        alert(this.errors);
      }
    },
    onSubmit() {
      // localStorage.setItem('shareCreditUsed', false); // for testing
      // return; // for testing
      
      let orderData = {};
      let time = moment()._d;
      orderData.Sales_Order_Lines = this.$store.state.cart.cartProductsList.Sales_Order_Lines;
      orderData.FinalPrice = this.TotalPrice;
      orderData.TotalPrice = this.necessaryCartItems.GrandTotal;
      orderData.GrandTotal = this.necessaryCartItems.GrandTotal;
      orderData.SalesOrder_id = this.salesOrderId;
      orderData.TimeSlot = time;
      orderData.card_reference = this.card_reference;
      orderData.PaymentMethod = this.paymentMethod;
      orderData.Billing_CustomerDetail_id = this.addressChoice.CustomerDetail_id;
      orderData.terminal = this.device;
      orderData.DispatchDate = this.deliveryTime;
      orderData.Deliver_CustomerDetail_id = this.addressChoice.CustomerDetail_id;
      orderData.PromoCode = this.PromoCode || this.necessaryCartItems.PromoCode;
      orderData.Savings = this.Savings;
      orderData.IsShareCreditUsed = this.IsShareCreditUsed;
      orderData.IsGroupBuy = 0;
      orderData.GroupBuyId = null;
      orderData.Billing_CustomerDetail_id = this.billingAddressSame ? this.addressChoice.CustomerDetail_id : this.billingAddress.CustomerDetail_id;
      const isUSA = localStorage.getItem('isUSA');
      if (isUSA === false || isUSA === 'false') {
        orderData.Tax = 0;
        orderData.Delivery = 24;
      } else {
        orderData.Delivery = this.shipstation.shipmentCost + this.shipstation.otherCost;
      }
      for (const key in this.necessaryCartItems) {
        if (!orderData.hasOwnProperty(key)) {
          orderData[key] = this.necessaryCartItems[key];
        }
      }

      let groupItemError = false;
      this.fetchGroupBuyWithId()
      .then(res => {
        res.data.record.map(r => {
          orderData.Sales_Order_Lines.map(j => {
            if (r.ProductNum === j.ProductNum) {
              groupItemError = true;
              this.detectedGroupItem = j;
              this.detectedGroupItemInv = r;
            }
          })
        });
        if (groupItemError === true && orderData.Sales_Order_Lines.length > 1) {
          this.detectedGroupItemModal = true;
        } else if (groupItemError === true && orderData.Sales_Order_Lines.length === 1) {
          orderData.IsGroupBuy = 1;
          orderData.GroupBuyId = this.detectedGroupItemInv.id;
          this.$store.dispatch("checkout/submitOrder", orderData);
        } else {
          orderData.IsGroupBuy = 0;
          orderData.GroupBuyId = null;
          this.$store.dispatch("checkout/submitOrder", orderData);
        }
      })
      .catch(err => {
        console.log('err', err)
      })
    },
    fetchCardToken() {
      let paymentData = {};
      paymentData.cardNum = this.cardForm.Card.split(" ").join("");
      paymentData.expDate =
        "20" + this.cardForm.Expiration.split("/").reverse().join("-");
      paymentData.cvv = this.cardForm.CVC;
      paymentData.salesOrderId = this.salesOrderId;
      paymentData.card_holder_name = this.cardForm.card_holder_name;
      // this.$store.dispatch('checkout/fetchACCardToken', paymentData)
      this.$store.dispatch("checkout/saveCreditCard", paymentData);
      this.isAddPayment = false;
    },
    addBilling() {
      // this never been use
      this.isAddBilling = !this.isAddBilling;
      if (this.billingAddress) {
        this.billingAddress = '';
      }
    },
    // this function not doing anything
    submitOrder(paymentData) {
      paymentData.card_reference = this.card_reference;
      this.$store.dispatch("checkout/submitOrder", paymentData);
    },
    validateAddress() {
      this.$store.dispatch("navbar/validateDeliveryRadius");
    },
    validateDeliveryRadiusCheckout(event) {
      this.$store.dispatch(
        "navbar/validateDeliveryRadius",
        this.addressChoice.Zip
      );
    },
    addAddress(priorAddress) {
      if (this.isAddAddress === true) {
        this.isAddAddress = false;
      } else {
        this.isAddAddress = true;
      }
    },
    filterAddresses(addresses) {
      // filter address
      let filter = [];
      const isUSA = (localStorage.getItem('isUSA')==='false') ? false : true;
      
      for (let i = 0; i < addresses.length; i++) {
        if (addresses[i].IsUSA === isUSA) {
          filter.push(addresses[i]);
        }
      }
      return filter;
    },
    isFormValidForSubmission() {
      let valid = false;
      if (this.paymentMethod === "creditcard") {
        if (this.cardSuccess) {
          valid = true;
        } else {
          valid = false;
        }
      } else if (
        this.paymentMethod === "wechatpay" ||
        this.paymentMethod === "alipay"
      ) {
        valid = true;
      }
      
      if (this.addressChoice === "" || (!this.billingAddress && !this.billingAddressSame)) {
        valid = false;
      }
      if (this.orderLoading || this.cardLoading || this.windowOpening) {
        valid = false;
      }
      if (this.$store.state.cart.cartProductsList.Sales_Order_Lines) {
        if (!this.$store.state.cart.cartProductsList.Sales_Order_Lines.length) {
          valid = false;
        }
      }
      if (this.paymentMethod === "") {
        valid = false;
      }
      if (!this.checkoutWithinRadius) {
        valid = false;
      }
      // if (this.deliveryTime === "") {
      //   valid = false;
      // }
      return valid;
    },
    goToProductDetail(product) {
      this.updateActiveProduct(product.ProductNum);
      this.$router.push({
        name: "productDetails",
        query: { productNum: product.ProductNum },
      });
    },
    selectShipstation(e, item) {
      let cartItems = {};
      cartItems.SalesOrder_id = this.$store.state.cart.cartProductsList.SalesOrder_id;
      cartItems.Sales_Order_Lines = this.$store.state.cart.cartProductsList.Sales_Order_Lines;
      cartItems.ShippingMethod = "Delivery";
      cartItems.Tip = 0;
      cartItems.TipPercentage = 0;
      cartItems.TotalPrice =  this.$store.state.cart.cartProductsList.TotalPrice;
      cartItems.PromoCode = this.PromoCode;
      const isUSA = localStorage.getItem('isUSA');
      if (isUSA === false || isUSA === 'false') {
        cartItems.Tax = 0;
        cartItems.Delivery = 24;
      } else {
        cartItems.Delivery = this.shipstation.shipmentCost + this.shipstation.otherCost;
      }
      cartItems.Zip = this.addressChoice.Zip;
      this.$store.dispatch('cart/saveAndAdjustCart', cartItems)
      .then( () => {
        this.saveTotalPrice(this.necessaryCartItems.TotalPrice);
      })
    },
    getItemQuantity: function() {
      if (isUserAuthenticated() && this.cartProductsList && this.cartProductsList.Sales_Order_Lines) {
        for (var i = 0; i < this.cartProductsList.Sales_Order_Lines.length; i++) {
          if (this.item.Product_id === this.cartProductsList.Sales_Order_Lines[i].Product_id) {
            this.num = this.cartProductsList.Sales_Order_Lines[i].Quantity;
            this.found = true;
          } 
        }
      } else {
        for (var i = 0; i < this.cartProductsList.length; i++) {
          if (this.item.Product_id === this.cartProductsList[i].Product_id) {
            this.num = this.cartProductsList[i].quantity;
            this.found = true;
          }
        }
      }
    },
    deleteItem(item) {
      if (isUserAuthenticated()) {
        this.$store.dispatch('cart/deleteCartItem', item.Product_id)
        .then(() => {
          this.confirmDeleteItem = false;
          this.$store.dispatch('cart/getCart');
        });
      }
    },
    decreaseAddToCart: function(item, e) {
      e.preventDefault();
      this.addDisabled = true;
      setTimeout(() => {
        this.addDisabled = false;
      }, 1000);
      let quantity = item.Quantity - 1;
      if (quantity < 1) {
        // this.deleteItem(item);
      } else {
        if (isUserAuthenticated()) {
          this.$store.dispatch('cart/updateItemQuantity', [item.Product_id, quantity])
          .then(() => {
            this.$store.dispatch('cart/getCart');
          });
        } else {
          item.quantity = quantity;
          this.$store.dispatch('cart/updateLocalCart', item)
          .then(() => {
            this.$store.dispatch('cart/fetchCartProducts')
          });
        }
      }
    },
    clearCreditCardForm() {
      this.cardForm.Card = '';
      this.cardForm.Expiration = '';
      this.cardForm.CVC = '';
      this.cardForm.card_holder_name = '';
    },
    clearAddressForm() {
      this.addressForm.name = '';
      this.addressForm.SSN = '';
      this.addressForm.FirstName = '';
      this.addressForm.LastName = '';
      this.addressForm.Telephone = '';
      this.addressForm.Street = '';
      this.addressForm.City = '';
      this.addressForm.Zip = '';
      this.addressForm.State = '';
    },
    throttleAddToCart:  _.debounce(function(item, event) {
      this.addDisabled = true;
      setTimeout(() => this.addDisabled = false, 1000);
      this.addThisToCart(item);
    }, 150, {'leading': true, 'trailing': true}),
    addThisToCart: function(item) {
      if (!this.addToCartLoading) {
        if (isUserAuthenticated()) {
          this.addProductToCart({success: this.handleAddToCartSuccess, fail: this.handleAddToCartFail, item, event: event})   
        } else {
          this.$store.dispatch('cart/incrementLocalCart', [item, event])
        }
      }
    },
    handleAddToCartSuccess(payload) {
      // flyToElement(payload.event.target, $('.cart-link')); 
      this.$store.dispatch('cart/addCart', payload.item)
      .then(() => {
        this.$store.dispatch('cart/getCart');
      });
    },
    handleAddToCartFail(product) {
      alert(`Sorry, there are only ${product.StockLevel} available of ${product.Name}`);
    },

  },
  mounted() {
    if (localStorage.getItem('shareCreditUsed') && (localStorage.getItem('shareCreditUsed') === true || localStorage.getItem('shareCreditUsed') === 'true')) {
      this.updateIsShareCreditUsed(true);
    } else {
      this.updateIsShareCreditUsed(false);
    }
    if (this.userDetails) {
      this.fetchMLMNetwork(this.userDetails.mobile_user_id);
    }
    // window.addEventListener('scroll', this.updateScroll);
    if (localStorage.getItem('isUSA') === true || localStorage.getItem('isUSA') === 'true') {
      this.addressForm.isUSA = localStorage.getItem('isUSA');
    }
  },
  beforeMount() {
    this.$store.dispatch("cart/getCart").then(() => {
      const cartItems = {};
      cartItems.SalesOrder_id = this.$store.state.cart.cartProductsList.SalesOrder_id;
      cartItems.Sales_Order_Lines = this.$store.state.cart.cartProductsList.Sales_Order_Lines;
      cartItems.ShippingMethod = "Delivery";
      cartItems.Tip = 0;
      cartItems.TipPercentage = 0;
      cartItems.TotalPrice = this.$store.state.cart.cartProductsList.TotalPrice;
      cartItems.IsShareCreditUsed = this.IsShareCreditUsed;
      const isUSA = localStorage.getItem('isUSA');
      if (isUSA === false || isUSA === 'false') {
        cartItems.Tax = 0;
        cartItems.Delivery = 24;
      } else {
        cartItems.Delivery = this.shipstation.shipmentCost + this.shipstation.otherCost;
      }
      this.$store.dispatch("cart/saveAndAdjustCart", cartItems).then(() => {
        this.saveTotalPrice(this.necessaryCartItems.TotalPrice);
      });
    });
    this.$store.dispatch("checkout/fetchTimeSlots");
    this.$store.dispatch("addresses/fetchAddresses");
  },
  watch: {
    timeSlots: function (newVal, oldVal) {
        this.timeSlots.map(t => {
          if (t.available === true) {
            this.deliveryTime = t.value;
            return;
          }
        });
    },
    wechatModalOpen: function (newVal, oldVal) {
      let that = this;
      if (newVal === true) {
        this.wechatTimeout = setTimeout(function() {
          localStorage.setItem('shareCreditUsed', true);
          that.updateIsShareCreditUsed(true);
        }, 5000);
      }
      if (newVal === false && this.wechatTimeout) {
        clearTimeout(this.wechatTimeout);
      }
    },
    IsCreditUsed: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        let cartItems = {};
        cartItems.SalesOrder_id = this.$store.state.cart.cartProductsList.SalesOrder_id;
        cartItems.Sales_Order_Lines = this.$store.state.cart.cartProductsList.Sales_Order_Lines;
        cartItems.ShippingMethod = "Delivery";
        cartItems.Tip = 0;
        cartItems.TipPercentage = 0;
        cartItems.TotalPrice = this.$store.state.cart.cartProductsList.TotalPrice;
        cartItems.IsCreditUsed = this.IsCreditUsed;
        cartItems.IsShareCreditUsed = this.IsShareCreditUsed;
        const isUSA = localStorage.getItem('isUSA');
      
        cartItems.Zip = this.addressChoice.Zip;
        this.$store.dispatch("cart/saveAndAdjustCart", cartItems).then(() => {
          this.saveTotalPrice(this.necessaryCartItems.TotalPrice);
        });
      }
    },
    IsShareCreditUsed: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        let cartItems = {};
        cartItems.SalesOrder_id = this.$store.state.cart.cartProductsList.SalesOrder_id;
        cartItems.Sales_Order_Lines = this.$store.state.cart.cartProductsList.Sales_Order_Lines;
        cartItems.ShippingMethod = "Delivery";
        cartItems.Tip = 0;
        cartItems.TipPercentage = 0;
        cartItems.TotalPrice = this.$store.state.cart.cartProductsList.TotalPrice;
        cartItems.IsCreditUsed = this.IsCreditUsed;
        cartItems.IsShareCreditUsed = this.IsShareCreditUsed;
        this.$store.dispatch("cart/saveAndAdjustCart", cartItems).then(() => {
          this.saveTotalPrice(this.necessaryCartItems.TotalPrice);
        });
      }
    },
    isAddAddress: function (newVal, oldVal) {
      immediate: true;
      if (newVal === true && oldVal === false) {
        this.addressChoice = "";
      }
    },
    addresses: function (newVal, oldVal) {
      if (newVal !== oldVal || newVal.length !== oldVal.length) {
        // this.addresses.map((address) => {
        //   if (address.IsDefault) {
        //     this.addressChoice = address;
        //     this.addressName = address.FirstName + " " + address.LastName;
        //   }
        // });
        let addressIndex = this.addresses.length - 1;
        if (addressIndex >= 0 ) {
          this.addressChoice = this.addresses[addressIndex];
          this.addressName = this.addresses[addressIndex].FirstName + " " + this.addresses[addressIndex].LastName;
        }
      }
    },
    addressChoice: function (newVal, oldVal) {
      if (newVal !== oldVal && newVal !== '') {
        
        let shipstationData = {};
        this.shipstation = '';
        shipstationData.tozip = this.addressChoice.Zip;
        shipstationData.SalesOrder_id = this.salesOrderId;
        
        // reset the error message for payment
        this.showPaymentError = false;
        
        if (newVal !== oldVal && !this.isAddBilling) {
          this.addresses.map((address) => {
            if (
              address.CustomerDetail_id === this.addressChoice.CustomerDetail_id
            ) {
              this.addressName = address.FirstName + " " + address.LastName;
            }
          });
          this.selectShipstation();
        }
        if (oldVal === "" && newVal !== oldVal && !this.isAddBilling) {
          this.isAddAddress = false;
        }
        if (!this.isAddBilling) {
          // if (shipstationData.tozip && shipstationData.SalesOrder_id) {
            this.$store.dispatch('checkout/fetchShipStationPrices', shipstationData);
          // }
        }
      }
    },
    cardLoading: function (newVal, oldVal) {
      if (oldVal === true && newVal === false) {
        this.isAddPayment = false;
      }
    },
    billingAddressSame: function(newVal, oldVal) {
      if (!newVal && newVal !== oldVal) {
        this.billingAddress = '';
      }
    },
    promoCodeSuccessful: function (newVal, oldVal) {
      if (newVal === true) {
        let value = (
          this.TotalPrice -
          this.Savings.toFixed(2) +
          this.necessaryCartItems.Tax +
          this.necessaryCartItems.Delivery
        ).toFixed(2);
        this.saveGrandTotal(Number(value));
      }
    },
    necessaryCartItems: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.updatePromoCode(this.necessaryCartItems.Savings);
      }
    },
    cartProductsList: {
      deep: true,
      handler(newVal) {
        if (newVal && this.$route.name === "purchase") {
          const cartItems = {};
          cartItems.SalesOrder_id = this.$store.state.cart.cartProductsList.SalesOrder_id;
          cartItems.Sales_Order_Lines = this.$store.state.cart.cartProductsList.Sales_Order_Lines;
          cartItems.ShippingMethod = "Delivery";
          cartItems.Tip = 0;
          cartItems.TipPercentage = 0;
          cartItems.TotalPrice = this.$store.state.cart.cartProductsList.TotalPrice;
          cartItems.IsShareCreditUsed = this.IsShareCreditUsed;
          this.resetShipstationData();
          const isUSA = localStorage.getItem('isUSA');
          if (isUSA === false || isUSA === 'false') {
            cartItems.Tax = 0;
            cartItems.Delivery = 24;
          }
          this.$store.dispatch("cart/saveAndAdjustCart", cartItems).then(() => {
            this.saveTotalPrice(this.necessaryCartItems.TotalPrice);
          });
          this.addressChoice = '';
          this.clearPromoCode();
          this.IsCreditUsed = false;
          this.clearCard();
        }
      },
    },
    shipstationResults: function(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        if (newVal.length === 1) {
          this.shipstation = newVal[0];
          this.selectShipstation();
        }
      }
    },
    networkData: function (newVal, oldVal) {
      if (newVal && newVal[0]) {
        this.config['url'] = "https://www.newbiotechcorp.com/home/" + newVal[0].id;
        this.sharing['url'] = "https://www.newbiotechcorp.com/home/" + newVal[0].id;
      }
    },
    $route(to, from) {
      if (to && to.path === '/purchase') {
        if (localStorage.getItem('shareCreditUsed') && (localStorage.getItem('shareCreditUsed') === true || localStorage.getItem('shareCreditUsed') === 'true')) {
        this.updateIsShareCreditUsed(true);
        } else {
          this.updateIsShareCreditUsed(false);
        }
      }
    },
  },
  beforeRouteLeave(to, from, next) {
    this.$store.dispatch("cart/getCart").then(() => {
      const cartItems = {};
      cartItems.SalesOrder_id = this.$store.state.cart.cartProductsList.SalesOrder_id;
      cartItems.Sales_Order_Lines = this.$store.state.cart.cartProductsList.Sales_Order_Lines;
      cartItems.ShippingMethod = "Delivery";
      cartItems.Tip = 0;
      cartItems.TipPercentage = 0;
      cartItems.TotalPrice = this.$store.state.cart.cartProductsList.TotalPrice;
      cartItems.IsShareCreditUsed = this.IsShareCreditUsed;
      this.$store.dispatch("cart/saveAndAdjustCart", cartItems).then(() => {
        this.saveTotalPrice(this.necessaryCartItems.TotalPrice);
      });
    });
    this.addressChoice = '';
    this.paymentMethod = '';
    this.IsCreditUsed = false;
    this.resetShipstationData();
    this.clearPromoCode();
    this.clearCard();
    this.clearCreditCardForm();
    next();
  },
  computed: mapState({
    salesOrderId: (state) => state.cart.cartProductsList.SalesOrder_id,
    card_reference: (state) => state.checkout.card_reference,
    timeSlots: (state) => state.checkout.timeSlots,
    addresses: (state) => state.addresses.customerDetails,
    customerDetails: (state) => state.profile.customerDetails,
    necessaryCartItems: (state) => state.cart.necessaryCartItems,
    cartProductsList: (state) => state.cart.cartProductsList,
    device: (state) => state.navbar.device,
    orderLoading: (state) => state.checkout.orderLoading,
    orderSuccessful: (state) => state.checkout.orderSuccessful,
    cardLoading: (state) => state.checkout.cardLoading,
    cardSuccess: (state) => state.checkout.cardSuccess,
    cardError: (state) => state.checkout.cardError,
    checkoutWithinRadius: (state) => state.navbar.checkoutWithinRadius,
    promoCodeLoading: (state) => state.checkout.promoCodeLoading,
    promoCodeSuccessful: (state) => state.checkout.promoCodeSuccessful,
    promoCodeError: (state) => state.checkout.promoCodeError,
    promoCodeValid: (state) => state.checkout.promoCodeValid,
    PromoCode: (state) => state.checkout.PromoCode,
    Savings: (state) => state.checkout.Savings,
    GrandTotal: (state) => state.checkout.GrandTotal,
    TotalPrice: (state) => state.checkout.TotalPrice,
    Tax: (state) => state.checkout.Tax,
    cartClicked: (state) => state.cart.cartClicked,
    itemCount: (state) => state.cart.itemCount,
    windowOpening: (state) => state.checkout.windowOpening,
    orderFailed: (state) => state.checkout.orderFailed,
    orderFailMessage: (state) => state.checkout.orderFailMessage,
    IsShareCreditUsed: (state) => state.checkout.IsShareCreditUsed,
    userDetails: (state) => state.auth.userDetails,
    networkData: (state) => state.addresses.networkData,
    shipstationResults: state => state.checkout.shipstationResults,
  }),
};
</script>

<style lang="less">
// @import 'vue-social-share/dist/client.css';
@import "../assets/css/purchase.less";
@import "../assets/css/animation.less";
@import "../assets/css/modal.less";
</style>



// WEBPACK FOOTER //
// src/view/purchase.vue